import type { AbstractControl, ValidationErrors } from '@angular/forms';
import { ADDRESS_VALIDATION_ERROR_KEYS } from './address-field.validators';
import { containsSpecialAddressKeywordInLine1 } from './special-address-keywords';

/**
 * Requires a civic street in line 2 when line 1 contains PO Box, Rural Route, or General Delivery.
 * Attach to addressLine2 for all sections (ship from, ship to, and return address);
 * a non-empty suiteAptUnit satisfies the requirement as a fallback.
 */
export function civicStreetRequiredWhenSpecialAddressLine1Validator(
  control: AbstractControl,
): ValidationErrors | null {
  const parent = control.parent;
  if (!parent) {
    return null;
  }

  const streetControl = parent.get('streetAddress');
  const streetAddress = typeof streetControl?.value === 'string' ? streetControl.value : '';
  if (!containsSpecialAddressKeywordInLine1(streetAddress)) {
    return null;
  }

  const civicLine = typeof control.value === 'string' ? control.value.trim() : '';
  if (civicLine.length > 0) {
    return null;
  }

  if (control === parent.get('addressLine2')) {
    const suiteControl = parent.get('suiteAptUnit');
    const suiteAptUnit = typeof suiteControl?.value === 'string' ? suiteControl.value.trim() : '';
    if (suiteAptUnit.length > 0) {
      return null;
    }
  }

  return { [ADDRESS_VALIDATION_ERROR_KEYS.civicStreetRequired]: true };
}
